module.exports = __webpack_public_path__ + "assets/e896467cde49f996a1c55aafd9f58f17.png";